import { createElement, useState } from "react";
import { Check, ChevronRight } from "lucide-react";

function Item({ it, close }) {
  const [open, setOpen] = useState(false);
  if (it.divider) return <div className="my-1 border-t border-slate-200" />;
  if (it.render) return <div className="px-3 py-2">{it.render(close)}</div>;
  const has = !!it.sub;
  return (
    <div className="relative" onMouseEnter={() => has && setOpen(true)} onMouseLeave={() => has && setOpen(false)}>
      <button type="button" data-testid={it.testid} disabled={it.disabled}
        onClick={() => { if (has) { setOpen((o) => !o); return; } it.onClick?.(); close(); }}
        className="w-full flex items-center gap-3 px-3 py-1.5 text-[13px] text-slate-800 hover:bg-slate-100 disabled:opacity-40 disabled:hover:bg-transparent text-left">
        <span className="w-4 flex justify-center">{it.checked ? <Check className="w-3.5 h-3.5" /> : it.icon}</span>
        <span className="flex-1 whitespace-nowrap">{it.label}</span>
        {it.shortcut && <span className="text-[11px] text-slate-500 ml-4">{it.shortcut}</span>}
        {has && <ChevronRight className="w-3.5 h-3.5 text-slate-500" />}
      </button>
      {has && open && (
        <div className="absolute left-full top-0 -ml-0.5 min-w-[200px] bg-white rounded-lg shadow-2xl border border-slate-200 py-1 z-50">
          {it.sub.map((s, i) => createElement(Item, { key: i, it: s, close }))}
        </div>
      )}
    </div>
  );
}

export default function MenuBar({ menus, openMenu, setOpenMenu }) {
  const close = () => setOpenMenu(null);
  return (
    <div className="flex items-center gap-0.5 relative select-none">
      {menus.map((m) => (
        <div key={m.label} className="relative">
          <button type="button" data-testid={`studio-menu-${m.label.toLowerCase()}`}
            onClick={() => setOpenMenu(openMenu === m.label ? null : m.label)}
            onMouseEnter={() => openMenu && setOpenMenu(m.label)}
            className={`px-2 py-0.5 rounded text-[14px] text-slate-800 hover:bg-slate-200/70 ${openMenu === m.label ? "bg-slate-200" : ""}`}>
            {m.label}
          </button>
          {openMenu === m.label && (
            <div data-testid={`studio-menu-${m.label.toLowerCase()}-dropdown`} className="absolute left-0 top-full mt-0.5 min-w-[240px] bg-white rounded-lg shadow-2xl border border-slate-200 py-1 z-50">
              {m.items.map((it, i) => <Item key={i} it={it} close={close} />)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
